<template>
	<div>
		<div class="contact_banner">
			<div class="kuang">
				<h1 class="ct_ban_tit">{{ $t('message.index61t') }}</h1>
			</div>
			<div class="bot_rol"  @click="scrollToSection('section2')"><img src="@/images/banner_logo_10.png"/></div>
		</div>
		
		<div class="contact2" id="section2">
			 <div class="contact2_left">
				 <div class="spec_h">CONTACT</div>
				 <div class="spec_p">{{ $t('message.index62t') }} <span>US</span></div>
			 </div>
			 
			 <div class="contact2_right">
				 <ul>
					 <li>
						 <img src="@/images/contact2_03.png"/>
						 <div class="contact2_list_txt">
							 <p class="lab">{{ $t('message.index65t') }}</p>
							 <p>{{ phone }}</p>
						 </div>
					 </li>
					 
					 <li>
						 <img src="@/images/contact2_07.png"/>
						 <div class="contact2_list_txt">
							 <p class="lab">{{ $t('message.index66t') }}</p>
							 <p>{{ email }}</p>
						 </div>
					 </li>
					 
					 <li>
						 <img src="@/images/contact2_11.png"/>
						 <div class="contact2_list_txt">
							 <p class="lab">{{ $t('message.index67t') }}</p>
							 <p>{{ address }}</p>
						 </div>
					 </li>
					 
					 <li>
						 <img src="@/images/contact2_15.png"/>
						 <div class="contact2_list_txt">
							 <p class="lab">Whatapp</p>
							 <p>{{ whatapp }}</p>
						 </div>
					 </li>
								 
					 
		
				 </ul>
			 </div>
		</div>
		

		<div class="map">
			<div v-if="$i18n.locale == 'zh-CN'">
				<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.819907525501!2d103.78283027578529!3d1.2818145617890535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bafb467a6f5%3A0x2502b2ac1b780545!2z5paw5Yqg5Z2h5be06KW_54-t6K6p6Lev!5e0!3m2!1szh-CN!2shk!4v1685677470949!5m2!1szh-CN!2shk" width="100%" height="600" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
			</div>
			<div v-else>
				<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8209315774916!2d103.7845215!3d1.2811569999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bafb467a6f5%3A0x2502b2ac1b780545!2sPasir%20Panjang%20Rd%2C%20Singapore!5e0!3m2!1sen!2s!4v1690424061382!5m2!1sen!2s" width="100%" height="600" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
			</div>
		</div>

	</div>
</template>

<script>
	import axios from 'axios';
	export default {
	  name: 'Contact',
	  data() {
	    return {
			phone:'+65 8622 6688',
			email:'kai@kaitech.com',
			address:'10-80 Pasir Panjang Rd, Singapore 117438',
			whatapp:'+65 8622 6688',
	    };
	  },
	  mounted() {
		//API 获取联系信息
	    //this.fetchContactInfo();
	  },
	  methods:{
		  scrollToSection(link) {
			this.$scrollToSection(link); // 调用全局方法
		  },
		  fetchContactInfo() {
			// 发起 API 请求
			axios
			  .get('/api/contact') 
			  .then(response => {
				// 请求成功，将获取的数据替换

			  })
			  .catch(error => {
				// 请求失败，显示错误信息

			  });
		  },
	  },
	};
</script>
